<ng-container>
	<div
		[uiColSpan]="12"
		*ngIf="viewModel.documents().length > 0; else noDocuments"
		class="flex flex-col divide-y divide-gray-200 border border-gray-200 rounded-2xl overflow-auto"
	>
		<div
			class="grid grid-cols-12 px-4 py-2 bg-gray-100 text-gray-700"
			data-intercom-target="word-documents-table-header"
		>
			<div class="col-span-8 flex gap-4 items-center h6 text-gray-700">
				<button
					class="flex items-center gap-2 hover:text-green-600 focus:outline-none"
					[class.text-green-600]="viewModel.sortDirections().title"
					(click)="onSort('title')"
					[testHook]="testHooks.DocumentNameButton"
				>
					Document Name
					<ng-container
						*ngTemplateOutlet="
							sortingIcon;
							context: {
								sorting: viewModel.sortDirections().title,
							}
						"
					></ng-container>
				</button>
				<div class="relative">
					<i-tabler
						name="search"
						class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
					></i-tabler>
					<input
						#searchInput
						placeholder="Search documents"
						class="p-sm pl-8 pr-4 py-1.5 rounded-lg border border-gray-200 w-full focus:outline-green placeholder:text-gray-500 min-w-96"
						[formControl]="searchFormControl"
						[testHook]="testHooks.Search"
					/>
					<ui-button
						*ngIf="searchFormControl.value"
						(click)="searchFormControl.setValue('')"
						preset="ICON_DEFAULT"
						size="xs"
						icon="x"
						class="absolute right-2 top-1/2 -translate-y-1/2"
						classes="!px-1 !py-1"
						[testHook]="testHooks.Button"
					>
					</ui-button>
				</div>
			</div>
			<div class="col-span-2 flex items-center">
				<button
					class="p-sm flex items-center gap-2 hover:text-green-600 focus:outline-none"
					[class.text-green-600]="viewModel.sortDirections().lastUpdated"
					(click)="onSort('lastUpdated')"
					[testHook]="testHooks.LastUpdatedButton"
				>
					Last Updated
					<ng-container
						*ngTemplateOutlet="
							sortingIcon;
							context: {
								sorting: viewModel.sortDirections().lastUpdated,
							}
						"
					></ng-container>
				</button>
			</div>
			<div class="col-span-2 flex justify-end items-center p-sm">Packages</div>
		</div>
		<ui-doc-list-item
			*ngFor="
				let docMeta of viewModel.filteredDocuments();
				trackBy: trackByDocumentId
			"
			[documentMetadata]="docMeta"
			[listView]="true"
			(documentClick)="onDocumentClick(docMeta)"
			(openDocumentInWord)="onOpenDocumentInWord(docMeta)"
			[analyticContext]="ANALYTIC_CONTEXT.MATTER_DOCUMENTS"
			[testHook]="testHooks.DocListItem"
		>
		</ui-doc-list-item>
	</div>
</ng-container>

<ng-template #noDocuments>
	<div
		[uiColSpan]="12"
		class="flex flex-col gap-y-4 bg-white rounded-2xl px-8 pt-20"
	>
		<img
			class="h-36 mx-auto mb-6"
			src="/assets/images/documents/empty-docs.svg"
			alt="No documents found"
		/>
		<div class="text-center flex flex-col gap-y-2 pb-20 max-w-500 mx-auto">
			<h4 class="h4 mb-0">Select 'Add' to add documents to your matter!</h4>
			<p class="p-sm text-gray-700 leading-relaxed">
				Browse over 100 documents in your template library.
			</p>
		</div>
	</div>
</ng-template>

<ng-template #sortingIcon let-sorting="sorting">
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		stroke-width="2"
		stroke-linecap="round"
		stroke-linejoin="round"
		class="icon icon-tabler icons-tabler-outline icon-tabler-selector"
	>
		<path stroke="none" d="M0 0h24v24H0z" fill="none" />
		<path
			d="M8 9l4 -4l4 4"
			[ngClass]="{
				'text-green-600': sorting === 'asc',
				'text-gray-300': sorting === 'desc',
			}"
		/>
		<path
			d="M16 15l-4 4l-4 -4"
			[ngClass]="{
				'text-green-600': sorting === 'desc',
				'text-gray-300': sorting === 'asc',
			}"
		/>
	</svg>
</ng-template>
